import { useNavigate } from "react-router-dom";
import { STRING, STRINGS } from "../constant";
import { IMAGES } from "../assets";
import { Header, LAView, LAText, LATextInput, LAButton } from "../components";
import {
  DELETE_BUNDLE_USER,
  DELETE_USER,
  GET_STORE_AUTH_DETAILS,
  UPDATE_PROFILE_DETAILS,
} from "../api/firebase_user";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { auth } from "../api/config";
import { IS_BUNDLE_APP } from "../../app_constant";
import { useContext, useState } from "react";
import { AuthContext } from "../context/AuthProvider";
import { SHOW_TOAST } from "../constant/utils";
import BackArrowIcon from "../components/BackArrowIcon";
import { ThemeContext } from "../context/ThemeProvider";
import { ErrorMessage, Formik } from "formik";
import { MixpanelContext } from "../context/MixpanelProvider";
import * as Yup from "yup";
import { motion, AnimatePresence } from "framer-motion";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faUser, 
  faEnvelope, 
  faSignInAlt, 
  faSignOutAlt, 
  faTrash,
  faExclamationTriangle,
  faChevronLeft
} from '@fortawesome/free-solid-svg-icons';
import useFeatureList from "../hooks/useFeatureList";

function Account() {
  const navigate = useNavigate();
  const { bundleData, profile, setProfileDetails, isSubscribe } =
    useContext(AuthContext);
  const { resetMixpanel } = useContext(MixpanelContext);
  const featureList = useFeatureList();
  const { theme, currentTheme } = useContext(ThemeContext);
  const [editble, setEditable] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [firstName, setFirstName] = useState(
    IS_BUNDLE_APP
      ? bundleData?.auth_first_name ?? ""
      : profile?.auth_first_name ?? ""
  );
  const [lastName, setLastName] = useState(
    IS_BUNDLE_APP
      ? bundleData?.auth_last_name ?? ""
      : profile?.auth_last_name ?? ""
  );
  const [email, setEmail] = useState(
    IS_BUNDLE_APP ? bundleData?.auth_email ?? "" : profile?.auth_email ?? ""
  );

  const [loginMethod, setLoginMethod] = useState(
    IS_BUNDLE_APP
      ? bundleData?.auth_login_provider ?? ""
      : profile?.auth_login_provider ?? ""
  );

  // Card animations
  const cardVariants = {
    hover: { 
      scale: 1.02,
      boxShadow: "0px 8px 15px rgba(0,0,0,0.1)",
      transition: { type: "spring", stiffness: 400, damping: 10 }
    }
  };

  // Helper function to get icon background color
  const getIconBg = () => {
    return currentTheme === 'light' ? theme?.icon_bg?.profile_light : theme?.icon_bg?.profile_dark;
  }

  // Helper function to get card background
  const getCardBackground = (iconBg) => {
    const baseColor = currentTheme === 'light' ? theme?.homeCard?.start_light : theme?.homeCard?.start_dark;
    const darkerShade = currentTheme === 'light' ? theme?.homeCard?.end_light : theme?.homeCard?.end_dark; 
    return {
      background: `linear-gradient(to right, ${baseColor}, ${darkerShade})`,
      borderLeft: `4px solid ${iconBg || (currentTheme === 'light' ? theme?.icon_bg?.profile_light : theme?.icon_bg?.profile_dark)}`
    };
  };

  // Helper function for text color
  const getTextColor = () => {
    return currentTheme === 'light' 
      ? theme?.text?.light
      : theme?.text?.dark;
  };

  // Helper function for border color
  const getBorderColor = () => {
    return currentTheme === 'light' 
      ? 'rgba(0,0,0,0.1)' 
      : 'rgba(255,255,255,0.2)';
  };

  const handleDeleteClick = () => {
    setIsModalOpen(true);
  };

  const handleConfirmDelete = () => {
    setIsModalOpen(false);
    deleteAccount();
  };

  const handleCancelDelete = () => {
    setIsModalOpen(false);
  };

  function getLoginMethod() {
    if (loginMethod == "google.com") {
      return "Sign in with Google";
    } else if (loginMethod == "apple.com") {
      return "Sign in with Apple";
    } else {
      return "Sign in with Email";
    }
  }

  function isEmailLogin() {
    if (loginMethod == "google.com") {
      return false;
    } else if (loginMethod == "apple.com") {
      return false;
    } else {
      return true;
    }
  }

  async function onSave() {
    const nameRegex = /^[A-Za-z]+$/;

    if (!firstName.trim()) {
      SHOW_TOAST(STRING.enter_first_name, "error");
    } else if (!lastName.trim()) {
      SHOW_TOAST(STRING.enter_last_name, "error");
    } else if (!nameRegex.test(firstName)) {
      SHOW_TOAST("Invalid first name", "error");
    } else if (!nameRegex.test(lastName)) {
      SHOW_TOAST("Invalid last name", "error");
    } else {
      setProfileDetails(firstName, lastName);
      navigate(-1);
    }
  }

  async function onSignuOut() {
    setLoading(true);
    await auth().signOut();
    setLoading(false);
    resetMixpanel();
    navigate("/login");
    localStorage.removeItem("appState");
  }

  async function deleteAccount() {
    setLoading(true);
    try {
    } catch (err) {
      console.error(err);
    }
    const uid = auth().currentUser?.uid;
    const provider = auth().currentUser?.providerData[0]?.providerId ?? "";
    const result = await DELETE_USER(uid);
    if (IS_BUNDLE_APP) {
      try {
        await DELETE_BUNDLE_USER(uid);
        localStorage.clear();
        navigate("/login");
      } catch (err) {
        console.error(err);
      }
    }
    try {
      const resultApps = await GET_STORE_AUTH_DETAILS();
      if (result.status == true) {
        setLoading(false);
        if (resultApps.status) {
          if (resultApps?.data?.apps?.length <= 1) {
            await auth().currentUser.delete();
          }
        }

        SHOW_TOAST("Your account has been deleted successfully", "success");
        localStorage.clear();
        navigate("/login");
      } else {
        setLoading(false);
        setTimeout(() => {
          SHOW_TOAST(result.error, "error");
        }, 1000);
      }
    } catch (e) {
      setLoading(false);
      setTimeout(() => {
        authError(e);
      }, 1000);
    }
    await onSignuOut();
  }

  function authError(error) {
    if (error.code == "auth/requires-recent-login") {
    } else {
    }
  }

  const handleSubmit = (value) => {
    setProfileDetails(value?.first_name, value?.last_name);
    SHOW_TOAST("Profile updated successfully", "success");
    navigate(-1);
  };

  const onEditProfileInfo = () => {
    setEditable(!editble);
  };

  const loginType = getLoginMethod();

  const validationSchema = Yup.object().shape({
    first_name: Yup.string()
      .min(2, "Enter atleast 2 characters")
      .required("Please enter the first name")
      .matches(/^(\S+$)/g, "First Name cannot contain blankspaces")
      .matches(/^[a-zA-Z]+$/, "Only alphabetic characters allowed"),
    last_name: Yup.string()
      .min(2, "Enter atleast 2 characters")
      .required("Please enter the last name")
      .matches(/^(\S+$)/g, "Last Name cannot contain blankspaces")
      .matches(/^[a-zA-Z]+$/, "Only alphabetic characters allowed"),
  });

  // Modal animations
  const modalVariants = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: { 
      opacity: 1, 
      scale: 1,
      transition: { 
        duration: 0.2,
        type: "spring",
        damping: 25,
        stiffness: 500
      }
    },
    exit: { 
      opacity: 0, 
      scale: 0.9,
      transition: { duration: 0.15 }
    }
  };

  const overlayVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 0.2 } },
    exit: { opacity: 0, transition: { duration: 0.15 } }
  };

  return (
    <div className="p-6">
      {/* Header */}
      <div className="flex items-center mb-6">
        <button
          className="rounded-lg border-2 p-2 mr-4 flex items-center justify-center"
          style={{ borderColor: currentTheme === "light" ? theme?.border_color?.light : theme?.border_color?.dark }}
          onClick={() => navigate(-1)}
        >
          <BackArrowIcon
            color={currentTheme === "light" ? theme?.text?.light : theme?.text?.dark}
          />
        </button>
        <h1 
          className="text-2xl font-semibold"
          style={{ color: getTextColor() }}
        >
          Account Setting
        </h1>
      </div>

      <div className="flex flex-col lg:flex-row lg:justify-between items-start space-y-4 lg:space-y-0 lg:space-x-4">
        {/* Profile Information Card */}
        <motion.div
          className="w-full lg:w-1/2 bg-white dark:bg-gray-800 rounded-xl overflow-hidden shadow-sm"
          whileHover="hover"
          variants={cardVariants}
        >
          <div style={getCardBackground(getIconBg())}>
            <div className="p-6">
              <h2 
                className="text-xl font-semibold mb-4"
                style={{ color: getTextColor() }}
              >
                Profile Information
              </h2>

              <Formik
                initialValues={{
                  first_name: firstName ?? "",
                  last_name: lastName ?? "",
                }}
                enableReinitialize
                onSubmit={handleSubmit}
                validationSchema={validationSchema}
              >
                {({
                  setFieldValue,
                  handleChange,
                  values,
                  errors,
                  handleBlur,
                  handleSubmit,
                }) => (
                  <form onSubmit={handleSubmit} className="space-y-6">
                    {featureList?.global.show_first_name && (
                      <div>
                        <label 
                          className="block text-sm font-medium mb-2"
                          style={{ color: getTextColor() }}
                        >
                          First Name
                        </label>
                        <div className="relative">
                          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                            <FontAwesomeIcon 
                              icon={faUser} 
                              className="text-gray-400" 
                            />
                          </div>
                          <input
                            type="text"
                            name="first_name"
                            id="first_name"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values?.first_name}
                            placeholder="First Name"
                            className="w-full pl-10 pr-4 py-3 rounded-lg border focus:outline-none focus:ring-2 focus:ring-blue-500"
                            style={{ 
                              backgroundColor: currentTheme === 'light' ? '#ffffff' : '#374151',
                              borderColor: getBorderColor(),
                              color: getTextColor() 
                            }}
                          />
                        </div>
                        <ErrorMessage
                          name="first_name"
                          component="div"
                          className="text-red-500 text-sm mt-1"
                        />
                      </div>
                    )}

                    {featureList?.global.show_last_name && (
                      <div>
                        <label 
                          className="block text-sm font-medium mb-2"
                          style={{ color: getTextColor() }}
                        >
                          Last Name
                        </label>
                        <div className="relative">
                          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                            <FontAwesomeIcon 
                              icon={faUser} 
                              className="text-gray-400" 
                            />
                          </div>
                          <input
                            type="text"
                            name="last_name"
                            id="last_name"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values?.last_name}
                            placeholder="Last Name"
                            className="w-full pl-10 pr-4 py-3 rounded-lg border focus:outline-none focus:ring-2 focus:ring-blue-500"
                            style={{ 
                              backgroundColor: currentTheme === 'light' ? '#ffffff' : '#374151',
                              borderColor: getBorderColor(),
                              color: getTextColor() 
                            }}
                          />
                        </div>
                        <ErrorMessage
                          name="last_name"
                          component="div"
                          className="text-red-500 text-sm mt-1"
                        />
                      </div>
                    )}

                    {(featureList?.global.show_first_name || featureList?.global.show_last_name) && (
                      <motion.button
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        type="submit"
                        className="w-full py-3 px-6 rounded-lg font-medium text-white"
                        style={{ backgroundColor: getIconBg() }}
                      >
                        Save
                      </motion.button>
                    )}
                  </form>
                )}
              </Formik>

              <div className="mt-6 pt-6 border-t" style={{ borderColor: getBorderColor() }}>
                <div className="mb-4">
                  <h3 
                    className="text-sm font-medium mb-1"
                    style={{ color: currentTheme === 'light' ? 'rgba(75,85,99,1)' : 'rgba(156,163,175,1)' }}
                  >
                    Email
                  </h3>
                  <div className="flex items-center">
                    <FontAwesomeIcon 
                      icon={faEnvelope} 
                      className="mr-2 text-gray-400" 
                    />
                    <p style={{ color: getTextColor() }}>
                      {email ? email : profile?.auth_email}
                    </p>
                  </div>
                </div>

                <div>
                  <h3 
                    className="text-sm font-medium mb-1"
                    style={{ color: currentTheme === 'light' ? 'rgba(75,85,99,1)' : 'rgba(156,163,175,1)' }}
                  >
                    Login Method
                  </h3>
                  <div className="flex items-center">
                    <FontAwesomeIcon 
                      icon={faSignInAlt} 
                      className="mr-2 text-gray-400" 
                    />
                    <p style={{ color: getTextColor() }}>
                      {loginType}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Account Actions Card */}
        <motion.div
          className="w-full lg:w-1/2 bg-white dark:bg-gray-800 rounded-xl overflow-hidden shadow-sm"
          whileHover="hover"
          variants={cardVariants}
        >
          <div style={getCardBackground(getIconBg())}>
            <div className="p-6">
              <h2 
                className="text-xl font-semibold mb-6"
                style={{ color: getTextColor() }}
              >
                Account Actions
              </h2>

              <div className="space-y-4">
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={onSignuOut}
                  className="w-full py-3 px-6 rounded-lg font-medium flex items-center justify-center"
                  style={{ 
                    backgroundColor: currentTheme === 'light' ? '#f3f4f6' : '#374151',
                    color: getTextColor() 
                  }}
                >
                  <FontAwesomeIcon icon={faSignOutAlt} className="mr-2" />
                  {STRINGS.sign_out}
                </motion.button>

                {featureList?.global.delete_account && (
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    onClick={handleDeleteClick}
                    className="w-full py-3 px-6 rounded-lg font-medium flex items-center justify-center bg-red-500 text-white hover:bg-red-600"
                  >
                    <FontAwesomeIcon icon={faTrash} className="mr-2" />
                    {STRINGS.delete_account}
                  </motion.button>
                )}
              </div>
            </div>
          </div>
        </motion.div>
      </div>

      {/* Delete Account Confirmation Modal */}
      <AnimatePresence>
        {isModalOpen && (
          <motion.div
            initial="hidden"
            animate="visible"
            exit="exit"
            variants={overlayVariants}
            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm"
          >
            <motion.div
              variants={modalVariants}
              className="bg-white dark:bg-gray-800 rounded-xl shadow-lg p-6 w-full max-w-md"
            >
              <div className="flex items-center mb-4">
                <div 
                  className="w-10 h-10 rounded-full flex items-center justify-center mr-4"
                  style={{ backgroundColor: '#ef4444' }}
                >
                  <FontAwesomeIcon 
                    icon={faExclamationTriangle} 
                    className="text-white" 
                  />
                </div>
                <h2 
                  className="text-xl font-semibold"
                  style={{ color: getTextColor() }}
                >
                  Warning
                </h2>
              </div>
              
              <p 
                className="mb-6"
                style={{ color: getTextColor() }}
              >
                This action will delete all your account and is irreversible. Are you sure you want to delete your account?
              </p>
              
              <div className="flex justify-end space-x-3">
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={handleCancelDelete}
                  className="py-2 px-4 rounded-lg font-medium"
                  style={{ 
                    backgroundColor: currentTheme === 'light' ? '#f3f4f6' : '#374151',
                    color: getTextColor() 
                  }}
                >
                  Cancel
                </motion.button>
                
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={handleConfirmDelete}
                  className="py-2 px-4 rounded-lg font-medium bg-red-500 text-white hover:bg-red-600"
                >
                  Yes, Delete
                </motion.button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default Account;